import StatementOfChangesInEquity from '../pages/StatementOfChangesInEquity';

const statementOfChangesInEquityRoute = {
  public: [],
  auth: [
    {
      name: 'statement_of_changes_in_equity',
      path: '/finance-and-accounting/statement-of-changes-in-equity',
      component: StatementOfChangesInEquity,
    },
  ],
};

export default statementOfChangesInEquityRoute;
